var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerraformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2725 5.67809V10.0951L14 7.88797V3.46629L10.2725 5.67809Z",
    fill: "#4040B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13625 3.46629L9.86375 5.67809V10.0951L6.13625 7.88527V3.46629ZM2 1V5.41937L5.7275 7.62925V3.20949L2 1ZM6.13625 12.7901L9.86375 15V10.5802L6.13625 8.37075V12.7901Z",
    fill: "#5C4EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraformIcon);
export default __webpack_public_path__ + "static/media/terraform_icon.efa958f3b84902c168e847d0335511f7.svg";
export { ForwardRef as ReactComponent };